'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'citrus-slice';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e2f5';
var svgPathData = 'M480 208c0 150.2-121.8 272-272 272-59.5 0-114.5-19.1-159.3-51.5l27.4-27.4c38.9 29.4 87.3 46.9 139.9 46.9 128.1 0 232-103.9 232-232 0-52.5-17.5-101-46.9-139.9l27.4-27.4C460.9 93.5 480 148.5 480 208zM176 412c-28.3-5.7-54.4-17.5-77-33.8l77-77 0 110.7zm32 3.8l0-122c18.4 4.6 38.2 1.8 54.9-8.4l82.8 82.8c-34.9 29.8-80.2 47.7-129.7 47.7-2.7 0-5.3-.1-8-.2zm77.8-152.7c10.7-16.5 14-36.5 9.8-55.2l120.3 0c.1 2.7 .2 5.3 .2 8 0 49.5-18 94.7-47.7 129.7l-82.5-82.5zM301.3 176l77-77c16.3 22.6 28 48.7 33.8 77l-110.7 0zm-37.3 37.3c3.7 13.4 .3 28.4-10.3 39s-25.5 14-39 10.3l49.2-49.2zM1.2 430.8c7.8 7.3 16.1 14.2 24.7 20.6 50.8 38.1 113.8 60.6 182.2 60.6 167.9 0 304-136.1 304-304 0-68.3-22.5-131.4-60.6-182.2-6.4-8.6-13.3-16.8-20.6-24.7L408.2 23.8 23.8 408.2 1.2 430.8z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCitrusSlice = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;